export * as PaymentExpectationApi from './api';

export enum InvestmentPaymentType {
  Banked = 'BANKED',
  ManuallyRecorded = 'MANUALLY_RECORDED',
  Reconciled = 'RECONCILED',
  CashBalance = 'CASH_BALANCE',
}
